module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftbar-view elffy-dashboard",
    class: {
      'left-aside-toggle': _vm.toggle_aside
    }
  }, [_c('section', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "material-table-widget dashboard_top_bar"
  }, [_c('button', {
    staticClass: "btn btn-default btn-new",
    attrs: {
      "id": "show-modal"
    },
    on: {
      "click": function($event) {
        _vm.ContactModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" 新增聯絡人")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group pull-right mt-0",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    class: {
      'active btn-success': _vm.order_type == 'new'
    },
    on: {
      "click": function($event) {
        _vm.order_type = 'new'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-sort-amount-down"
  }), _vm._v(" 新到舊(" + _vm._s(_vm.orderdObjects('new').length) + ")")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    class: {
      'active btn-success': _vm.order_type == 'old'
    },
    on: {
      "click": function($event) {
        _vm.order_type = 'old'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-sort-amount-up"
  }), _vm._v(" 舊到新(" + _vm._s(_vm.orderdObjects('old').length) + ")")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    class: {
      'active btn-success': _vm.order_type == 'revenue'
    },
    on: {
      "click": function($event) {
        _vm.order_type = 'revenue'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-dollar-sign"
  }), _vm._v(" 成交額排序(" + _vm._s(_vm.orderdObjects('revenue').length) + ")")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    class: {
      'active btn-success': _vm.order_type == 'active'
    },
    on: {
      "click": function($event) {
        _vm.order_type = 'active'
      }
    }
  }, [_c('i', {
    staticClass: "far fa-smile"
  }), _vm._v(" 活躍(" + _vm._s(_vm.orderdObjects('active').length) + ")")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    class: {
      'active btn-success': _vm.order_type == 'silence'
    },
    on: {
      "click": function($event) {
        _vm.order_type = 'silence'
      }
    }
  }, [_c('i', {
    staticClass: "far fa-frown"
  }), _vm._v(" 沈默(" + _vm._s(_vm.orderdObjects('silence').length) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "widget-wrap"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("聯絡人列表 (" + _vm._s(_vm.orderdObjects(this.order_type).length) + ")")]), _vm._v(" "), (_vm.order_type == 'revenue') ? _c('p', [_vm._v(" 透過成交額排序，掌握你營收80%來源的20%重要客戶 ")]) : _vm._e(), _vm._v(" "), (_vm.order_type == 'active') ? _c('p', [_vm._v(" 2個月內有交易互動的公司，掌握這些公司，持續創造新訂單 ")]) : _vm._e(), _vm._v(" "), (_vm.order_type == 'silence') ? _c('p', [_vm._v(" 2個月以上沒有交易的公司，快去與他們保持聯繫重新建立關係！ ")]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('th', [_vm._v("成交交易")]), _vm._v(" "), _c('th', [_vm._v("成交率")]), _vm._v(" "), _c('th', [(_vm.order_type == 'revenue') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _vm._e(), _vm._v(" 營收占比")]), _vm._v(" "), _c('th', [(_vm.order_type == 'active') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _vm._e(), _vm._v(" "), (_vm.order_type == 'silence') ? _c('i', {
    staticClass: "fas fa-arrow-up"
  }) : _vm._e(), _vm._v(" \n                  \t最後交易時間\n                  ")]), _vm._v(" "), _c('th', [(_vm.order_type == 'new') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _vm._e(), _vm._v(" "), (_vm.order_type == 'old') ? _c('i', {
    staticClass: "fas fa-arrow-up"
  }) : _vm._e(), _vm._v(" \n                  \t建立時間\n                  ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.orderdObjects(this.order_type)), function(person) {
    return _c('tr', {
      staticClass: "pointer",
      attrs: {
        "align": "left"
      }
    }, [_c('td', {
      on: {
        "click": function($event) {
          _vm.ShowContact(person.contact_token)
        }
      }
    }, [_vm._v(_vm._s(person.name))]), _vm._v(" "), _c('td', {
      on: {
        "click": function($event) {
          _vm.ShowOrganization(person.organization_token)
        }
      }
    }, [_vm._v(_vm._s(person.organization_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(person.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(person.phone))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(person.deal_sum.toLocaleString()) + ", " + _vm._s(person.won_deal) + "筆")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(person.won_rate) + "%")]), _vm._v(" "), _c('td', [(_vm.total_revenue != 0) ? _c('span', [_vm._v(_vm._s(Math.round(person.deal_sum * 1000 / _vm.total_revenue) / 10) + "%")]) : _c('span', [_vm._v("0%")])]), _vm._v(" "), _c('td', [_vm._v("\n                  \t" + _vm._s(person.last_deal_at) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                  \t" + _vm._s(person.created_at) + "\n                  ")])])
  }))])])])])])]), _vm._v(" "), (_vm.ContactModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.ContactModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.ContactModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    attrs: {
      "name": "header"
    }
  }, [_vm._v("\n              新增聯絡人\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.ContactModal = false
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body j-forms",
    staticStyle: {
      "overflow": "initial !important"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input left-icon-input"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control login-frm-input",
    attrs: {
      "type": "text",
      "placeholder": "姓名*",
      "name": "name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("不可為空值\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input left-icon-input"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control login-frm-input",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input left-icon-input"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-control login-frm-input",
    attrs: {
      "type": "text",
      "placeholder": "電話"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input left-icon-input"
  }, [_vm._m(7), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "url": _vm.axios.defaults.baseURL + '/settings/auto_complete',
      "anchor": "name",
      "label": "contact_name",
      "param": "keyword",
      "name": "autocomplete",
      "placeholder": "公司名稱",
      "classes": {
        input: 'form-control login-frm-input organization_name',
        wrapper: 'input-wrapper'
      },
      "process": _vm.process_organization_JSON,
      "onSelect": _vm.handle_organization_Select,
      "onInput": _vm.set_organization_Value,
      "customHeaders": _vm.auth_token,
      "customParams": {
        type: 'organization'
      }
    },
    model: {
      value: (_vm.organization_name),
      callback: function($$v) {
        _vm.organization_name = $$v
      },
      expression: "organization_name"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.validateBeforeSubmit
    }
  }, [_vm._v("\n                建立\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.ContactModal = false
      }
    }
  }, [_vm._v("\n                取消\n              ")])])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" 名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('i', {
    staticClass: "fa fa-building"
  }), _vm._v(" 公司")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" Email")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" 電話")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "text"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "text"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "text"
    }
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "text"
    }
  }, [_c('i', {
    staticClass: "fa fa-building"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-271d3c4e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contacts/ContactList.vue
// module id = 678
// module chunks = 4